
import { WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import Component from "../../../components/Component";
import withAxios, { IAxiosProps } from "../../../components/withAxios";
import Headerpage from "src/components/header";
import "src/pages/home/signUp-pages/style.css";
import { AppContextConsumer, IAppContext } from "src/components/withAppContext";
import { Redirect, withRouter } from 'react-router-dom';
import Footerpage from "src/components/footer";
// import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Box } from '@material-ui/core/';
// import { Edit } from '@material-ui/icons-material';
const styles = () => ({
  childTemplate: {
    paddingLeft: 80,
  },
  listItem: {
    "&:hover": {
      backgroundColor: "#e6e6e6",
    },
    backgroundColor: "white",
  },
});

type IProps = IAxiosProps & IAppContext &
  WithStyles<keyof ReturnType<typeof styles>> & { history: any };

interface ITemplatesPageState {
  firstName: any
  lastName: any
  firstNameErr: any
  lastNameErr: any
  loader: boolean;
  redirect: boolean

}

const Home = withStyles(styles)(
  withAxios(

    class SignUpStepOne extends Component<IProps, ITemplatesPageState> {

      public state = this.buildState({
        firstName: '',
        lastName: '',
        firstNameErr: '',
        lastNameErr: '',
        loader: false,
        redirect: false
      });

      public constructor(props: any) {
        super(props);
      }

      public componentWillMount() {
        this.props.getNewLoginUserDetails();
      }

      public componentDidMount() {
        this.setState({ redirect: false });
        window.scrollTo({ top: 0, behavior: "smooth" });
        if (this.props?.newUserDetails?.firstName) {
          this.setState({ firstName: this.props.newUserDetails.firstName });
        }
        if (this.props?.newUserDetails?.lastName) {
          this.setState({ lastName: this.props.newUserDetails.lastName });
        }
      }

      public nextHandler() {
        const alphabetRegex = /^[A-Za-z]+$/;
        const lastNameRegex=/^[A-Za-z\s-]+$/
        this.setState({ lastNameErr: '', firstNameErr: '' });
        const { firstName, lastName } = this.state;
        if (firstName?.trim() !== "" && lastName.trim() !== "") {
          if (alphabetRegex.test(firstName.trim()) && lastNameRegex.test(lastName.trim())) {
            this.props.onChangeUserDetails({ ...this.props?.newUserDetails, firstName:firstName.trim(), lastName:lastName.trim() });
            // this.setState({ redirect: true });
            this.props.history.push('/school')
          } else {
            if (!alphabetRegex.test(firstName.trim())) {
              this.setState({ firstNameErr: 'Enter valid First Name' });
            }
            if (!lastNameRegex.test(lastName.trim())) {
              this.setState({ lastNameErr: 'Enter valid Last Name' });
            }
          }

        } else {
          if (firstName?.trim() === "") {
            this.setState({ firstNameErr: 'First name is required' });
          }
          if (lastName?.trim() === "") {
            this.setState({ lastNameErr: 'Last name is required' });
          }
        }
      }

      
      public render() {
        return (
          <>
            {this.state.redirect && <Redirect to="/school" />}
           <Headerpage/>
            <div className="container-inner">
              <div className="content-leader" style={{
                width: "100%",
                height: "calc(100vh - 153px)",
                backgroundImage: `-webkit-gradient(linear, left top, left bottom, from(rgba(62, 124, 177, 0.5)), to(rgba(62, 124, 177, 0.5))),url(${require('src/assets/homepage_img.jpg')})`,
                backgroundPosition: 'center'
              }}>
                <div className="welcome-backs">
                  <div className="sign-In-backs name-inner-page">
                    <h1>Welcome to Grit Leadership!<br />
                      Let's start with your name.</h1>
                      
                    <form>
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 p-0">
                          <input type="text" className="form-control firstControl" placeholder="First Name"
                            value={this.state.firstName}
                            onChange={(event) => {
                              this.setState({ firstName: event.target.value });
                            }} />
                          {this.state.firstNameErr !== "" && <div className="span-error" style={{ color: 'red' }}>{this.state.firstNameErr}</div>}
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 p-0">
                          <input type="text" className="form-control lastControl" placeholder="Last name" value={this.state.lastName}
                            onChange={(event) => {
                              this.setState({ lastName: event.target.value });
                            }} />
                          {this.state.lastNameErr !== "" && <div className="span-error lastspanerror" style={{ color: 'red'}}>{this.state.lastNameErr}</div>}
                        </div>
                      </div>
                    </form>
                    <button className="sign-btn" onClick={() => {
                      this.nextHandler();
                    }}><span className="next-span-btn">NEXT</span></button>
                  </div>
                </div>
              </div>
            </div>
          <Footerpage/>
          </>
        );
      }
    }
  )
);



const HomeFunction = (props: any) => {
  // console.log("propspropspropsprops",props)
  return (
    <AppContextConsumer>{(context) => <Home {...context} history={props?.history} />}</AppContextConsumer>
  )
};
export default withRouter(HomeFunction);





// WEBPACK FOOTER //
// ./src/pages/home/name/name.tsx